import { Injectable } from '@angular/core';
import { Portfolio, WebUserDataConstants } from '@ddt-web/domain';

import { PortfolioDirector } from '../directors/portfolio-director';

@Injectable({
	providedIn: 'root'
})
export class PortfolioFactory {

	public getAllPortfoliosFromUserDataJson(responseJson: any): Portfolio[] {
		const portfolios = [];
		(responseJson?.resultMap?.SEARCH_RESULTS?.[0]?.resultList ?? [])
			.filter(resultData => this.isPortfolioCompatible(resultData))
			.forEach(portfolioData => {
				portfolios.push(new PortfolioDirector().construct(portfolioData));
			});
		return portfolios;
	}

	public getAllPortfoliosFromPortfolioAnalysisResponse(responseJson: any): Portfolio[] {
		const portfolios = [];
		(responseJson?.resultMap?.PORTFOLIOS?.[0]?.portfolios ?? [])
			.forEach(portfolioData => {
				if (portfolioData?.success) {
					portfolios.push(new PortfolioDirector().construct(portfolioData));
				} else {
					console.error(`Portfolio Analysis Unsuccessful: ${JSON.stringify(portfolioData)}`);
				}
			});
		return portfolios;
	}

	private isPortfolioCompatible(json: any): boolean {
		return (json.type && json.type === WebUserDataConstants.TYPE.PORTFOLIO) || (json.type === WebUserDataConstants.TYPE.PORTFOLIO_LIKE && !json.preferenceKey);
	}

}
